export const BOOKMARKS_PAGE_SIZE = 10

export interface BookmarkCardViewModel {
  id: string
  subjectTitle: string
  yearLabel: string
  topicPath: string
  snippet: string
  hasSolution: boolean
}
